import React from "react";
import loadable from "@loadable/component";
import Background from "@components/Dashboard/Pro/Shared/Background";
import ReviewsList from "./ReviewsList";
import ReviewsDialog from "@components/Dashboard/Pro/Shared/ReviewsDialog";
import ImageDialog from "@components/Global/Custom/ImageDialog";

import { observer } from "mobx-react-lite";


const Reviews = observer(() => {
	return (
		<Background>
			<ReviewsList />
			
			<ReviewsDialog />
			<ImageDialog />
		</Background>
	);
});

export default Reviews;
export const loader = (route) =>
	loadable(() => import("./Reviews.component"), { ssr: !!route.ssr });
